import { Helmet } from "react-helmet"
import menuLink from '../../HappyHourMenu.pdf'
import happyImage from '../../assets/images/menu-HappyHour.png'

export default function Specials(){
  return (
    <div className="pageStyles happy-hour">
      <Helmet>
        <title>Happy Hour in Orange Beach, AL | Villaggio Grille</title>
        <meta name="description" content="Join Villaggio for Happy Hour Celebrations!" />
      </Helmet>

      <div id="happyhour-page" className="fullSec pageBody bg-cream">
        <div className="pgHeader">
          <h1>Happy Hour Specials</h1>
          <h2>2-6pm · 7 Days a Week</h2>
          <p>*Coupons can not be applied</p>
        </div>
        <div className="mainWrap">
          <div className="sectionWrap medDef">
            <div className="fullSec">
              <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
                <img src={happyImage} alt="Villaggio's Happy Hour Menu" className="hhImg bshadow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

